import type { ReactNode } from 'react'

import type { AppInitialProps } from '../@types/app.types.js'
import { usePrivateNetworkGuard } from './hooks/usePrivateNetworkGuard.js'
import { useRedirectAuthUser } from './hooks/useRedirectAuthUser.js'
import { useRedirectUnconfirmedUser } from './hooks/useRedirectUnconfirmedUser.js'

type RouteGuardProps = {
  pageProps: AppInitialProps
  children: ReactNode
}

export const RouteGuard = (props: RouteGuardProps) => {
  const { pageProps, children } = props
  const { networkPublicInfo, role, member } = pageProps.authToken || {}

  usePrivateNetworkGuard(role?.type, networkPublicInfo?.visibility)
  useRedirectAuthUser(role?.type)
  useRedirectUnconfirmedUser(member, role)

  return <>{children}</>
}
